export enum ComponentSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  Mini = 'mini',
}
